export const FLOOR_KEY = 'lm_calculator';
